<template>
  <div class="configurator-header">
    <div
      class="configurator-header__container configurator-header__container--left"
    >
      <slot name="left"></slot>
    </div>
    <div
      v-if="$scopedSlots.center"
      class="configurator-header__container configurator-header__container--center"
    >
      <slot name="center"></slot>
    </div>
    <div
      class="configurator-header__container configurator-header__container--right"
    >
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfiguratorHeader',
};
</script>

<style lang="scss" scoped>
.configurator-header {
  display: flex;
  color: $color-primary;
  align-items: center;
  transition: transform $default-transition-duration;
  height: 100%;
  padding: 0.375rem 0.625rem;

  &__container {
    $container-element: &;

    &--left,
    &--right {
      flex: 1;
      min-width: 0;
    }

    &--right {
      flex: none;
      justify-content: flex-end;
    }
  }

  @include breakpoint($breakpoint-l) {
    padding: 0.375rem 0;
  }
}
</style>
